import PropTypes from 'prop-types';
import { values } from 'ramda';

export const FINANCIAL_PUBLICATION = {
  FULL_YEAR_RESULTS: 'full-year-results',
  GREEN_BOND: 'green-bond',
  HALF_RESULTS: 'half-results',
  INVESTOR_PRESENTATIONS: 'investor-presentations',
  PRESS_RELEASE: 'press-release',
  REFERENCE_DOCUMENT: 'reference-document',
  URD: 'urd',
  RSE_REPORT: 'rse-report',
};

export const FinancialPublicationType = PropTypes.oneOf(
  values(FINANCIAL_PUBLICATION)
);
